module.exports = __webpack_public_path__ + "static/media/e-learning_implement.501cf5f8.jpg";